import { UseQueryOptions } from '@tanstack/react-query';

import { DisplayTemplate } from '@crossnokaye/typescript-sdk/models/components';

import { equipmentBrowserPreviewEquipmentBrowserView } from '@repo/sdk/funcs/equipmentBrowserPreviewEquipmentBrowserView';
import { EquipmentBrowserViewResponse } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { PreviewEquipmentBrowserViewRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { GaiaQueryWithAgentId } from '@/queries/types';
import { hashValue } from '@/utils/hash';

interface PreviewEquipmentBrowserViewQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
  viewId?: string;
  displayTemplate: DisplayTemplate;
}

export const previewEquipmentBrowserViewQuery = ({
  agentId,
  viewId,
  client,
  displayTemplate,
}: PreviewEquipmentBrowserViewQueryProps): UseQueryOptions<
  EquipmentBrowserViewResponse,
  SDKError,
  EquipmentBrowserViewResponse | undefined
> => {
  const templateHash = hashValue(displayTemplate);

  return {
    // While viewId is optional, we only want to fetch it if it is provided to prevent multiple queries for the same agentId
    enabled: !!agentId && !!viewId,
    queryKey: [agentId, 'previewEquipmentBrowserView', viewId, templateHash],
    queryFn: () =>
      client<PreviewEquipmentBrowserViewRequest, EquipmentBrowserViewResponse>({
        gaiaFunc: equipmentBrowserPreviewEquipmentBrowserView,
        request: {
          agentId: agentId!,
          body: {
            displayTemplate: JSON.stringify(displayTemplate),
            viewId: viewId,
          },
        },
      }),
    staleTime: Infinity,
  };
};
